// Order statuses + helpers for the admin UI
export const ORDER_STATUSES = [
  { key: "new", label: "Nova", color: "bg-sky-100 text-sky-800" },
  { key: "confirmed", label: "Confirmada", color: "bg-indigo-100 text-indigo-800" },
  { key: "preparing", label: "Em preparação", color: "bg-amber-100 text-amber-800" },
  { key: "ready", label: "Pronta para entrega", color: "bg-emerald-100 text-emerald-800" },
  { key: "in_route", label: "Em rota", color: "bg-purple-100 text-purple-800" },
  { key: "delivered", label: "Entregue", color: "bg-green-100 text-green-800" },
  { key: "cancelled", label: "Cancelada", color: "bg-red-100 text-red-800" },
];

export const STATUS_LABEL = Object.fromEntries(ORDER_STATUSES.map((s) => [s.key, s.label]));
export const STATUS_COLOR = Object.fromEntries(ORDER_STATUSES.map((s) => [s.key, s.color]));

// Status transitions for quick actions (from -> [allowed next])
export const NEXT_STATUSES = {
  new: ["confirmed", "cancelled"],
  confirmed: ["preparing", "cancelled"],
  preparing: ["ready", "cancelled"],
  ready: ["in_route", "delivered", "cancelled"],
  in_route: ["delivered", "cancelled"],
  delivered: [],
  cancelled: [],
};

export const PAYMENT_METHODS = [
  { key: "mbway", label: "MB Way" },
  { key: "transferencia", label: "Transferência" },
  { key: "dinheiro_entrega", label: "Dinheiro à entrega" },
];

export const PAYMENT_METHOD_LABEL = Object.fromEntries(
  PAYMENT_METHODS.map((m) => [m.key, m.label])
);

export const PAYMENT_STATUSES = [
  { key: "pending", label: "Por receber", color: "bg-amber-100 text-amber-800" },
  { key: "paid", label: "Pago", color: "bg-green-100 text-green-800" },
  { key: "refunded", label: "Reembolsado", color: "bg-gray-100 text-gray-700" },
];

export const PAYMENT_STATUS_LABEL = Object.fromEntries(
  PAYMENT_STATUSES.map((s) => [s.key, s.label])
);
export const PAYMENT_STATUS_COLOR = Object.fromEntries(
  PAYMENT_STATUSES.map((s) => [s.key, s.color])
);

export const DELIVERY_PERIODS = [
  { key: "manha", label: "Manhã" },
  { key: "tarde", label: "Tarde" },
];
